import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ServiceAppService } from './../../../security/service-app.service';
import { IFiltros, ITotais } from './interface-apuracao-vdm-acessorio';
import { ApuracaoVdmAcessorioHistoricoJaguarComponent } from './apuracao-vdm-acessorio-historico-jaguar/apuracao-vdm-acessorio-historico-jaguar.component';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { ApuracaoVdmAcessorioHistoricoLandRoverComponent } from './apuracao-vdm-acessorio-historico-land-rover/apuracao-vdm-acessorio-historico-land-rover.component';
import { CurrencyPipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { ApuracaoVdmAcessorioService } from './apuracao-vdm-acessorio.service';

@Component({
  selector: 'app-apuracao-vdm-acessorio',
  templateUrl: './apuracao-vdm-acessorio.component.html',
  styleUrls: ['./apuracao-vdm-acessorio.component.scss']
})
export class ApuracaoVdmAcessorioComponent implements OnInit {
  cols: any[];
  colsFooter: any[];
  dados: any[];
  loading: boolean;
  nomeModulo: string;

  filtros: IFiltros = {
    dataAno: null,
    considerarBalcao: false,
    selecaoVdm: true
  };

  //Váriáveis do dropDown de Ano para o filtro.
  ano: any;
  anoAtual = new Date();
  anoAnterior = new Date();
  anoRetrasado = new Date();
  anoPosterior = new Date();
  anoDropDown: any[] = [];

  totais: ITotais = {
    totalBudgetFull: 0,
    totalBudgetYtd: 0,
    totalPendenteFull: 0,
    totalPendenteYtd: 0,
    totalRealizado: 0,
    totalValorComDesconto: 0,
    totalValorDesconto: 0
  }

  parametros: string = '';

  @ViewChild('dt') dt: Table;
  // @ViewChild('principal') apuracaoVdmAcessorioPrincipalJaguar: ApuracaoVdmAcessorioPrincipalJaguarComponent;
  @ViewChild('historicoJaguar') apuracaoVdmAcessorioHistoricoJaguar: ApuracaoVdmAcessorioHistoricoJaguarComponent
  // @ViewChild('principal') apuracaoVdmAcessorioPrincipalLandRover: ApuracaoVdmAcessorioPrincipalLandRoverComponent;
  @ViewChild('historicoLandRover') apuracaoVdmAcessorioHistoricoLandRover: ApuracaoVdmAcessorioHistoricoLandRoverComponent
  constructor(private service: ServiceAppService,
    private exportExcelService: ExportExcelService,
    private currency: CurrencyPipe,
    private apuracaoVdmAcessorioService: ApuracaoVdmAcessorioService
  ) {
    this.nomeModulo = 'Apuração VDM - Acessórios';
  }

  ngOnInit(): void {
    this.geraAnoDropDown();
    this.setaValorData();

    this.cols = [
      { field: 'codDealer', header: 'Dealer', width: 'width:120px' },
      { field: 'nomeDealer', header: 'Nome', width: 'width:200px'  },
      { field: 'budgetFull', header: 'Budget Full', type: this.currency, arg1: 'BRL', width: 'width:120px' },
      { field: 'budgetYtd', header: 'Budget YTD', type: this.currency, arg1: 'BRL', width: 'width:120px' },
      { field: 'realizado', header: 'Realizado', type: this.currency, arg1: 'BRL', width: 'width:120px' },
      { field: 'valorDesconto', header: 'Valor Desconto', type: this.currency, arg1: 'BRL', width: 'width:120px' },
      { field: 'valorComDesconto', header: 'Valor c/ Desconto', type: this.currency, arg1: 'BRL', width: 'width:120px' },
      { field: 'pendenteFull', header: 'Pendente Full', type: this.currency, arg1: 'BRL', width: 'width:120px' },
      { field: 'pendenteYtd', header: 'Pendente YTD', type: this.currency, arg1: 'BRL', width: 'width:120px' },
    ];
  }

  /**
   * Mapeia os dados do backend refatorado removendo os prefixos (a_, b_, c_, etc.)
   */
  private mapearDadosBackendRefatorado(item: any): any {
    return {
      idDealer: item.a_idDealer,
      codDealer: item.b_codDealer,
      nomeDealer: item.c_nomeDealer,
      budgetFull: item.d_budgetFull,
      budgetYtd: item.e_budgetYtd,
      realizado: item.f_realizado,
      pendenteFull: item.g_pendenteFull,
      pendenteYtd: item.h_pendenteYtd,
      budgetFullMes: item.i_budgetFullMes,
      budgetMtd: item.j_budgetMtd,
      realizadoMes: item.k_realizadoMes,
      gapMesFull: item.l_gapMesFull,
      gapMesYtd: item.m_gapMesYtd,
      mensal: item.mensal,
      valorDesconto: item.n_valorDesconto,
      valorComDesconto: item.o_valorComDesconto,
      valorDescontoMes: item.p_valorDescontoMes,
      valorComDescontoMes: item.q_valorComDescontoMes,
      totalVeiculos: item.totalVeiculos
    };
  }

  ngAfterViewInit() {
    this.retornaDados();
  }

  retornaDados() {
    this.loading = true;
    
    // Define loading nos componentes filhos
    if (this.apuracaoVdmAcessorioHistoricoJaguar) {
      this.apuracaoVdmAcessorioHistoricoJaguar.loading = true;
    }
    if (this.apuracaoVdmAcessorioHistoricoLandRover) {
      this.apuracaoVdmAcessorioHistoricoLandRover.loading = true;
    }
    
    // Carrega dados principais
    this.apuracaoVdmAcessorioService.buscarDadosPrincipais(this.filtros).subscribe(res => {

      // Mapeia os dados removendo os refixos (a_, b_, c_, etc.) do backend refatorado
      this.dados = res.dados?.map(item => this.mapearDadosBackendRefatorado(item)) || [];
      console.log('Dados após mapeamento:', this.dados);

      this.totais = {
        totalBudgetFull: res.totalBudgetFull,
        totalBudgetYtd: res.totalBudgetYtd,
        totalPendenteFull: res.totalPendenteFull,
        totalPendenteYtd: res.totalPendenteYtd,
        totalRealizado: res.totalRealizado,
        totalValorComDesconto: res.totalValorComDesconto,
        totalValorDesconto: res.totalValorDesconto
      }
      this.loading = false;
    });

    // Carrega dados do histórico Jaguar
    this.apuracaoVdmAcessorioService.buscarDadosHistoricoJaguar(this.filtros).subscribe(res => {
      if (this.apuracaoVdmAcessorioHistoricoJaguar) {
        this.apuracaoVdmAcessorioHistoricoJaguar.atualizarDados(res.dados, res);
      }
    });

    // Carrega dados do histórico Land Rover
    this.apuracaoVdmAcessorioService.buscarDadosHistoricoLandRover(this.filtros).subscribe(res => {
      if (this.apuracaoVdmAcessorioHistoricoLandRover) {
        this.apuracaoVdmAcessorioHistoricoLandRover.atualizarDados(res.dados, res);
      }
    });
  }

  setaValorData() {
    if (this.filtros.dataAno === undefined || this.filtros.dataAno === null) {
      this.filtros.dataAno = this.anoAtual.getFullYear();
    }

    // Não chama retornaDados() aqui para evitar duplicação
    // Os dados serão carregados no ngAfterViewInit
  }

  alteraValorFiltroVdm() {
    this.retornaDados();
  }

  set Ano(ano: any) { this.filtros.dataAno = this.tratarSetDropDown(ano); }
  get Ano(): any { return this.tratarGetDropDown(this.filtros.dataAno); }

  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  private geraAnoDropDown() {
    this.anoDropDown = [
      { name: this.anoRetrasado.getFullYear() - 2, code: this.anoRetrasado.getFullYear() - 2 },
      { name: this.anoAnterior.getFullYear() - 1, code: this.anoAnterior.getFullYear() - 1 },
      { name: this.anoAtual.getFullYear(), code: this.anoAtual.getFullYear() },
      { name: this.anoPosterior.getFullYear() + 1, code: this.anoPosterior.getFullYear() + 1 }
    ]
  }

  public exportExcel() {
    let registros = [];
    let registrosHistoricoJaguar = [];
    let registrosHistoricoLandRover = [];

    this.apuracaoVdmAcessorioService.buscarDadosParaExportacao(this.filtros).subscribe(res => {
      // Mapeia os dados removendo os prefixos do backend refatorado
      registros = res.dados?.map(item => this.mapearDadosBackendRefatorado(item)) || [];

      if (registros.length > 0) {
        this.exportExcelService.nomeModulo = this.nomeModulo;
        this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
          let linha = {};

          this.cols.forEach(c => {
            linha[(c.header)] = (r[c.field]);
          });

          return linha;
        }));
      }
    });

    this.apuracaoVdmAcessorioService.buscarDadosParaExportacaoJaguar(this.filtros).subscribe(res => {
      registrosHistoricoJaguar = res.dados;

      if (registrosHistoricoJaguar.length > 0) {
        this.exportExcelService.nomeModulo = "Apuração VDM - Acessórios/Histórico - Jaguar";
        this.exportExcelService.ExportTOExcelJSON(registrosHistoricoJaguar.map(r => {
          let linha = {};

          this.apuracaoVdmAcessorioHistoricoJaguar.cols.forEach(c => {
            linha[(c.header)] = (r[c.field]);
          });
          return linha;
        }));
      }
    });

    this.apuracaoVdmAcessorioService.buscarDadosParaExportacaoLandRover(this.filtros).subscribe(res => {
      registrosHistoricoLandRover = res.dados;

      if (registrosHistoricoLandRover.length > 0) {
        this.exportExcelService.nomeModulo = "Apuração VDM - Acessórios/Histórico - Land Rover";
        this.exportExcelService.ExportTOExcelJSON(registrosHistoricoLandRover.map(r => {
          let linha = {};

          this.apuracaoVdmAcessorioHistoricoLandRover.cols.forEach(c => {
            linha[(c.header)] = (r[c.field]);
          });
          return linha;
        }));
      }
    });
  }

  downloadExcel(dados: any) {
    this.apuracaoVdmAcessorioService.buscarDadosAnaliticos(dados.codDealer, this.filtros).subscribe({
      next: (response: any[]) => {
        const dadosFormatados = response.map((item: any) => ({
          'Cod. Dealer': this.sanitizeExcelValue(item.codDealer, false),
          'Nome Dealer': this.sanitizeExcelValue(item.nomeDealer, false),
          'Data Emissão': this.formatarDataHora(item.dataEmissao),
          'Valor Realizado': this.sanitizeExcelValue(item.valorRealizado, true),
          'Valor Desconto': this.sanitizeExcelValue(item.valorDesconto, true),
          'Valor c/ Desconto': this.sanitizeExcelValue(item.valorComDesconto, true),
          'Código': this.sanitizeExcelValue(item.codigo, false),
          'Nota': this.sanitizeExcelValue(item.nota, false),
          'Número OS': this.sanitizeExcelValue(item.numeroOs, false),
          'Tipo OS': this.sanitizeExcelValue(item.tipoOs, false)
        }));

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dadosFormatados);
        const workbook: XLSX.WorkBook = { Sheets: { 'Analitico': worksheet }, SheetNames: ['Analitico'] };
        const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        const urlBlob = window.URL.createObjectURL(blob);
        link.href = urlBlob;
        link.download = 'analitico_apuracao_vdm_acessorio.xlsx';
        link.click();
        window.URL.revokeObjectURL(urlBlob);
      },
      error: (err) => {
        console.error('Erro ao gerar arquivo:', err);
      }
    });
  }

  private sanitizeExcelValue(value: any, isNumeric: boolean = false): any {
    if (value === null || value === undefined || value === '') {
      return isNumeric ? 0 : '';
    }
    if (isNumeric) {
      const numValue = parseFloat(value);
      return isNaN(numValue) ? 0 : numValue;
    }
    return String(value).trim();
  }

  formatarDataHora(dataHora: string): string {
    if (!dataHora) return '';

    const [dataParte, horaParte] = dataHora.split(' ');
    const [ano, mes, dia] = dataParte.split('-');
    const horaLimpa = horaParte ? horaParte.split('.')[0] : '';

    return `${dia}/${mes}/${ano} ${horaLimpa}`;
  }
}
